import * as environment from "../environment";

import React, { createContext, useCallback, useContext, useMemo } from "react";

import { PropTypes } from "prop-types";
import { auth } from '../components/system-components/landing-page/firebase-config';
import { jwtDecode } from "jwt-decode"
import { signOut } from 'firebase/auth';
import { useLocalStorage } from "./useLocalStorage";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage("jwt", null);

    const navigate = useNavigate();

    const exchangeAuthTokenForAppJWT = async (token, endpoint) => {
        return fetch(`${environment.default.gatewayBaseUrl}/auth${endpoint}`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
        }).catch(() => {
            throw new Error("Service unavalible.")
        })
    };

    const userDetails = useCallback(() => {
        const decoded = jwtDecode(user);

        return decoded;
    }, [user]);

    const login = useCallback(async (data, endpoint = '/auth0') => {
        try {
            let result = await exchangeAuthTokenForAppJWT(data, endpoint);
            let jsonResult = await result.json();
            let jwt = jsonResult.jwt;

            if (jwt) {
                setUser(jwt);
                const lastPath = localStorage.getItem('lastPath') || '/';
                return navigate(lastPath);
            } else {
                if (jsonResult) throw Error(JSON.stringify(jsonResult));
                else {
                    throw Error({
                        error: "Unexpected Error",
                        message: "Invalid Payload (refer to console)",
                    });
                }
            }
        } catch (ex) {
            console.error(ex);
        }
        navigate('/login');

    }, [setUser, navigate]);

    const logout = useCallback(async () => {
        return signOut(auth).finally(() => {
            window.localStorage.setItem('jwt', '');
            navigate('/login');
        });
    }, [navigate]);

    const value = useMemo(
        () => ({
            user,
            login,
            logout,
            userDetails
        }),
        [user, login, logout, userDetails]
    );
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export function isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

AuthProvider.propTypes = {
    children: PropTypes.object
}
